export default __webpack_public_path__ + "static/media/BrixSansBold.ae22aa5f.woff";